<!-- Header section -->
<login-header></login-header>

<!-- Hero section -->
<div class="lp_hero gradient_bg" style="background-image: url('/assets/images/homehero-bg.webp');">
    <div class="lp_hero_content d-grid align-items-center">
        <div class="lp_hero_text">
            <h1 class="lp_h1">Uniting Families <span class="display-block"> Empowering Advisors</span>  <span class="display-block">Securing Futures Together</span></h1>
            <!-- <p>Store all your important information:</p>
            <ul class="info_list">
                <li>Financial Planning</li>
                <li>Wills and Estate Plans</li>
                <li>Medical Records</li>
                <li>Passwords </li>
                <li>Banking Information</li>
                <li>Video Recordings for the ones you love</li>
            </ul> -->
            <a href="/questionnaires" class="primary_btn" title="How it works">Start free trial</a>
            <p class="trust-text">Trusted, Compliant & Secure</p>
             <ul class="security_logos d-flex align-items-center">
                <li class="nav-item">
                    <img src="/assets/images/hipaa-complaint.svg" alt="Hipaa Compliant" loading="lazy">
                </li>
                <li class="nav-item">
                    <img src="/assets/images/gdrp-ready.svg" alt="GDPR Ready" loading="lazy">
                </li>
                <li class="nav-item">
                    <img src="/assets/images/ccpa-ready.svg" alt="CCPA Ready" loading="lazy">
                </li>
                <li class="nav-item">
                    <img src="/assets/images/secured-by-sectigo.svg" alt="Secured By Sectigo" loading="lazy">
                </li>
                <li class="nav-item">
                    <img src="/assets/images/duns-registered.svg" alt="D-U-N-S Registered" loading="lazy">
                </li>
            </ul>
        </div>
        <div class="lp_hero_image">
            <img class="w-100 d-none d-md-block" fetchpriority="high" src="/assets/images/lp-hero-dsknew.webp" alt="">
            <img class="w-100 d-block d-md-none" fetchpriority="high" src="/assets/images/lp-hero-dsknew-mbl.webp" alt="">
        </div>
    </div>
</div>

<div class="lp_features">
    <div class="px-90 m-auto text-center">
        <div class="features_top">
            <h2 class="lp_h2 mb-5">Family Central gives you peace of mind and provides the support you need in times of
                crises and inevitable emergencies.</h2>
        </div>

        <div class="features_list d-grid">
            <div class="single_feature">
                <a type="button" data-bs-toggle="modal" data-bs-target="#appmodal" class="info_btn"> Download the app
                </a>
                <div class="feature_img mb-4 mt-4">
                    <img src="/assets/images/secure-app.svg" width="80" height="145" alt="" loading="lazy">
                </div>
                <h3 class="lp_h3 mb-3">One Simple, <br>Secure App</h3>
                <p class="lp_p">Everything you need to organize your most important documents so you can spend time with
                    what matters most –your family.</p>
            </div>
            <div class="single_feature">
                <a routerLink="/professional" class="info_btn">For Professionals</a>
                <div class="feature_img mb-4 mt-4">
                    <img src="/assets/images/financial-advisors.svg" width="152" height="145" alt="" loading="lazy">
                </div>
                <h3 class="lp_h3 mb-3">A Benefit Financial Advisors Can Offer Their Clients</h3>
                <p class="lp_p">Organize and manage your clients’ important documents and information in a safe,
                    digitized platform.</p>
            </div>
            <div class="single_feature">
                <a routerLink="/families" class="info_btn">For Families</a>
                <div class="feature_img mb-4 mt-4">
                    <img src="/assets/images/lasting-legacy.svg" alt="" width="145" height="145" loading="lazy">
                </div>
                <h3 class="lp_h3 mb-3">A Lasting <br>Legacy</h3>
                <p class="lp_p">Prepare a secure legacy that can last for generations to come with all your information
                    in a safe haven that’s accessible by your loved ones at any time.</p>
            </div>
        </div>
    </div>
</div>


<div class="right_place gradient_bg" style="background-image: url('/assets/images/carousel-bg.webp');">
    <div class="px-90 m-auto">
        <div class="right_place_top text-center">
            <h2 class="h2 text-capitalize">Everything In The Right Place</h2>
        </div>

        <div class="right_place_carousel">
            <div id="rightPlaceCarousel" class="carousel slide" data-bs-ride="carousel">
                <!-- Indicators/dots -->
                <div class="carousel-indicators">
                    <button type="button" data-bs-target="#rightPlaceCarousel" data-bs-slide-to="0" class="active">1</button>
                    <button type="button" data-bs-target="#rightPlaceCarousel" data-bs-slide-to="1">2</button>
                    <button type="button" data-bs-target="#rightPlaceCarousel" data-bs-slide-to="2">3</button>
                    <button type="button" data-bs-target="#rightPlaceCarousel" data-bs-slide-to="3">4</button>
                </div>

                <!-- The slideshow/carousel -->
                <!-- The slideshow/carousel -->
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <div class="carousel_content">
                            <div class="carousel_caption">
                                <h3 class="h3">Family Photos & Videos</h3>
                                <p class="paragraph">Share and archive your family photos and videos for generations to
                                    come.</p>
                            </div>
                            <div class="carousel_image">
                                <img src="/assets/images/family-photos-videos-slide.webp" alt="Family Photos & Videos" class="w-100" fetchpriority="high" loading="lazy">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item legacy_videos">
                        <div class="carousel_content">
                            <div class="carousel_caption">
                                <h3 class="h3">Legacy Messages</h3>
                                <p class="paragraph">Give comfort to your loved ones by creating personal messages for
                                    them or important legal or personal information stored in your personal vault and
                                    released at your request.</p>
                            </div>
                            <div class="carousel_image">
                                <img src="/assets/images/legacy-videos-slide.webp" alt="Legacy Messages" class="w-100" loading="lazy">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item personal_vault">
                        <div class="carousel_content">
                            <div class="carousel_caption">
                                <h3 class="h3">Personal Vault & Files</h3>
                                <p class="paragraph">Your trusted Financial Advisor can help you store, organize and
                                    plan important documents like wills, estate planning, and passwords in a secure
                                    digital platform that is easily accessible to you.</p>
                            </div>
                            <div class="carousel_image">
                                <img src="/assets/images/personal-vault-slide.webp" alt="Personal Vault & Files" class="w-100" loading="lazy">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item private_calendar">
                        <div class="carousel_content">
                            <div class="carousel_caption">
                                <h3 class="h3">Private Calendars</h3>
                                <p class="paragraph">A private calendar for your family to share for creating lasting
                                    memories together and connect with those that matter most.</p>
                            </div>
                            <div class="carousel_image">
                                <img src="/assets/images/private-calendar-slide.webp" alt="Private Calendars" class="w-100" loading="lazy">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Left and right controls/icons -->
                <div class="carousel_control">
                    <button class="carousel-control-prev" type="button" data-bs-target="#rightPlaceCarousel" data-bs-slide="prev">
                        <img width="51" height="51" src="/assets/images/arrow-circle-left.svg" alt="<" loading="lazy">
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#rightPlaceCarousel" data-bs-slide="next">
                        <img width="51" height="51" src="/assets/images/arrow-circle-right.svg" alt=">" loading="lazy">
                    </button>
                </div>

            </div>
        </div>

    </div>
</div>

<div class="preparing_death">
    <div class="px-90 m-auto">
        <div class="preparing_death_content d-grid">
            <div class="preparing_death_text">
                <h2 class="lp_h2 mb-3 mb-lg-5 text-capitalize">Preparing for your death is an act of love</h2>
                <p class="lp_p mb-4">You can take steps today to take care of your loved ones even after your passing.
                </p>
                <p class="lp_p mb-3 mb-lg-5">You can record stories to preserve your family history; be part of special
                    milestones that happen after you are gone (such as a child’s birthday or a wedding); and share your
                    last wishes with your loved ones to help them navigate a terrible and overwhelming time.</p>
                <a routerLink="/questionnaires" class="border_btn red_border">Start your free trial</a>
            </div>
            <div class="preparing_death_img">
                <img class="w-100" src="/assets/images/preparing-death.webp" alt="" loading="lazy">
            </div>
        </div>
    </div>
</div>

<div class="important_things gradient_bg" style="background-image: url('/assets/images/carousel-bg.webp');">
    <div class="px-90 m-auto text-center">
        <div class="important_things_top">
            <h2 class="lp_h2 text-capitalize">All your most important information always at your fingertips</h2>
            <p class="lp_p">With Family Central, you can have all of your most important information at your fingertips,
                from making sure the kids make it to soccer on time to protecting your family’s legacy for generations
                to come.</p>
        </div>

        <div class="important_things_bottom d-grid">
            <div class="single_things">
                <div class="single_things_text">
                    <img src="/assets/images/family-vault.svg" width="75" height="75" alt="" loading="lazy">
                    <h3 class="h3">Family Vault</h3>
                    <p>Multigenerational planning and organization for your family.</p>
                </div>
                <div class="single_things_img">
                    <img src="/assets/images/family-vault-screen.webp" alt="" loading="lazy">
                </div>
            </div>
            <div class="single_things">
                <div class="single_things_text">
                    <img src="/assets/images/legacy-vault.svg" width="70" height="70" alt="" loading="lazy">
                    <h3 class="h3">Legacy Vault</h3>
                    <p>Create and protect your legacy for generations to come.</p>
                </div>
                <div class="single_things_img">
                    <img src="/assets/images/legacy-vault-screen.webp" alt="" loading="lazy">
                </div>
            </div>
            <div class="single_things">
                <div class="single_things_text">
                    <img src="/assets/images/live-customer-care.svg" width="75" height="75" alt="" loading="lazy">
                    <h3 class="h3">Live Customer Care</h3>
                    <p>Dedicated customer care and concierge support in all things Family Central.</p>
                </div>
                <div class="single_things_img">
                    <img src="/assets/images/customer-care-screen.webp" alt="" loading="lazy">
                </div>
            </div>
            <div class="single_things">
                <div class="single_things_text">
                    <img src="/assets/images/personal-vault-things.svg" width="73" height="73" alt="" loading="lazy">
                    <h3 class="h3">Personal Vault</h3>
                    <p>Organize all your important documents and information in one place.</p>
                </div>
                <div class="single_things_img">
                    <img src="/assets/images/personal-vault-screen.webp" alt="" loading="lazy">
                </div>
            </div>
        </div>
    </div>
</div>

<div class="get_started_section">
    <div class="get_started_content d-grid align-items-center">
        <div class="get_started_image">
            <img class="w-100" src="/assets/images/get-started-image.webp" alt="" loading="lazy">
        </div>
        <div class="get_started_box">
            <h2 class="h2 mb-4 text-capitalize">Ready to get started with Family Central?</h2>
            <form [formGroup]="emailForm">
                <div class="form-group get_started_field">
                    <input type="text" name="email" id="email" class="form-control" placeholder="Enter your email address" formControlName="email">
                    <button type="submit" class="primary_btn" (click)="goToOnboard()">Sign up</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Footer section -->
<app-footer></app-footer>


<!--App modal-->
<div class="modal fade" tabindex="-1" role="dialog" id="appmodal" aria-labelledby="appmodal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 640px;">
        <div class="modal-content ">
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            <div class="modal-body">
                <div class="img-section py-3">
                    <img src="/assets/images/secure-personal-application.webp" alt="mobile app">
                </div>
                <div class="text-section bgcolor-black d-flex align-items-center py-3 text-center">
                    <div class=" my-0 mx-auto">
                        <div>
                            <ul class="widget_links">

                                <li class="nav-item app_store">
                                    <a class="nav-link" type="button" href="https://apps.apple.com/in/app/familycentral-family-office/id6476486249" target="_blank" rel="noopener"><img src="/assets/images/apple-download-badge.svg" width="170" height="60" alt="Download apple" loading="lazy"></a>
                                </li>
                                <li class="nav-item app_store">
                                    <a class="nav-link" type="button" href="https://play.google.com/store/apps/details?id=com.familycentral.client" target="_blank" rel="noopener"><img src="/assets/images/playstore-icon.svg" width="170" height="60" alt="Download apple" loading="lazy"></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>